import PeriodEndsDashboard from './PeriodEndsDashboard';

export default PeriodEndsDashboard; 